import React from "react";
import { view } from "@risingstack/react-easy-state";

const Widget = view(({ children }) => {
  return <div className="w-full h-full">{children}</div>;
});

export default Widget;
